export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5261.0b2c8a8f.jpg";